import { Dialog } from 'primereact/dialog'
import React, { useMemo } from 'react'
import { useAwardYears } from '../../Hooks/Features/Awards/useAwardYears'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AwardCategories from './AwardCategories';
import { dateConvert, renderField } from '../../utils/Helper';
import AwardNominations from './AwardNominations';
import { SkeletonContainer } from '../Loader/Loader';
import CommanDialog from '../CommonCompo/CommanDialog/CommanDialog';
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { useCommon } from '../../Hooks/Common/useCommon';

const AwardYears = ({ filterValues, setFilterValues }) => {

    const { years, setYears, createYear, setCreateYear, createYearFields, handleChange, saveYear, loader, deleteYear } = useAwardYears({ filterValues, setFilterValues });
    const { getValuePermission } = useCommon();
    const addPermission = useMemo(() => !getValuePermission("awards_year_btn"), []);

    return (
        <div>
            <div className='mt-2 d-flex gap-2 p-2' style={{ height: "calc(100vh - 105px)", backgroundColor: "#dddddd4d" }}>
                <div className='w25 p-2 rounded'>
                    {addPermission &&
                        <div className='text-right'>
                            <button className='sk-btn sk-btn-primary bg-black text-white' onClick={() => setCreateYear({ visible: true })}><FontAwesomeIcon icon="fa-solid fa-plus" /> Year</button>
                        </div>
                    }
                    <div className='d-flex flex-column gap-2 mt-2' style={{ height: "calc(100% - 30px)", overflowY: 'auto' }}>
                        {loader?.data ?
                            Array.from({ length: 5 }, (_, index) => <div key={index} style={{ height: "40px" }}><SkeletonContainer /></div>)
                            :
                            (years?.map(year => (
                                <div key={year?.year_id} className='bg-white p-2 rounded shadow-sm fw-semibold c-pointer award-year d-flex justify-content-between align-items-center'
                                    style={{ border: `1px solid ${year?.year_id === filterValues?.year?.year_id ? "#f59f0b79" : "#dfdfdf"}` }}
                                    onClick={() => setFilterValues((prev) => ({ ...prev, year, categoryApiCall: true, nomineeApiCall: true, category: {} }))}
                                    title={`${year?.year_name} · ${year?.ceremony_name} \n${dateConvert(year?.ceremony_date, "day-mon-year")}`}
                                    onMouseEnter={() => { if (addPermission) { setFilterValues((prev) => ({ ...prev, hoveredYear: year })); } }}
                                    onMouseLeave={() => { if (addPermission) { setFilterValues((prev) => ({ ...prev, hoveredYear: {} })); } }}
                                >
                                    <div className='text-truncate w90' style={{ color: year?.year_id === filterValues?.year?.year_id ? "#f59e0b" : "" }}>{year?.year_name}{year?.ceremony_name && ` · ${year?.ceremony_name}`}</div>
                                    {(addPermission && filterValues?.hoveredYear?.year_id === year?.year_id) &&
                                        <div className='d-flex gap-2'>
                                            <div onClick={(e) => { e?.stopPropagation(); setCreateYear((prev) => ({ ...prev, visible: true, ...year })) }}><FontAwesomeIcon icon="fa-solid fa-pen-to-square" /></div>
                                            <div className='text-danger' onClick={(e) => { e?.stopPropagation(); setCreateYear((prev) => ({ ...prev, delete: { confirm: true, year } })) }}><FontAwesomeIcon icon={faTrashCan} /></div>
                                        </div>
                                    }
                                </div>
                            )))}
                    </div>
                </div>
                <div className='w75 d-flex gap-2'>
                    <div className='bg-white py-3 px-4 rounded shadow-sm w50 h-100'>
                        <AwardCategories filterValues={filterValues} setFilterValues={setFilterValues} years={years} />
                    </div>
                    <div className='bg-white py-3 px-4 rounded shadow-sm w50 h-100'>
                        <AwardNominations filterValues={filterValues} setFilterValues={setFilterValues} years={years} />
                    </div>
                </div>
            </div>

            <Dialog visible={createYear?.visible} onHide={() => setCreateYear({ visible: false })} draggable={false} header="Add Award Year" className='modal-xsmall'>
                <div>
                    {createYearFields?.map((field, index) => (
                        renderField(field, index, (e) => { handleChange(field, e) }, createYear)
                    ))}
                    <div className='d-flex gap-1 justify-content-end'>
                        <button className='sk-btn sk-btn-primary' onClick={() => setCreateYear({ visible: false })}>Cancel</button>
                        {loader?.btn ?
                            <button className="sk-btn sk-btn-primary bg-black text-white" style={{ width: "75px" }}>
                                <div className="spinner-border" role="status" style={{ width: "12px", height: "12px" }}>
                                    <span className="sr-only"></span>
                                </div>
                            </button> : <button className='sk-btn sk-btn-primary bg-black text-white' onClick={() => saveYear()}>Save Year</button>
                        }
                    </div>
                </div>
            </Dialog>

            <CommanDialog visible={createYear?.delete?.confirm} handleClose={() => setCreateYear({ visible: false })} handleFun={() => deleteYear()} message={`Are you sure you want to delete the year: ${createYear?.delete?.year?.year_name || ""} ${createYear?.delete?.year?.ceremony_name ? ` · ${createYear?.delete?.year?.ceremony_name}` : ""}?`} loader={loader?.delete} />
        </div>
    )
}

export default AwardYears